import styled from 'styled-components';
import { memo } from 'react';

export const InputWrapper = memo(styled.div`
  overflow: hidden;
  width: 356px;
  box-sizing: border-box;
`);

export const StyledInput = styled.input`
  width: 356px;
  outline: none;
  border: none;
  background: ${(props) => props.theme.main.textarea};
  height: 40px;
  vertical-align: middle;
  font-family: Roboto;
  color: ${(props) => props.theme.main.fontColor};
  font-size: 20px;
  padding-left: 15px;
  padding-right: 15px;
  box-sizing: border-box;
  &::placeholder{
    color: ${(props) => props.theme.main.placeholderText};
    }
`;
